import * as ActionTypes from "../Types/ActionTypes";

export const FeedbackQuestion = (
  state = {
    isLoading: true,
    errMess: null,
    feedbackQuestions: [],
  },
  action
) => {
  switch (action.type) {
    case ActionTypes.FETCH_FEEDBACKQUESTIONS:
      return {
        ...state,
        isLoading: false,
        errMess: null,
        feedbackQuestions: action.payload,
      };

    case ActionTypes.FEEDBACKQUESTIONS_LOADING:
      return {
        ...state,
        isLoading: true,
        errMess: null,
        feedbackQuestions: [],
      };

    case ActionTypes.FEEDBACKQUESTIONS_FAILED:
      return {
        ...state,
        isLoading: false,
        errMess: action.payload,
        feedbackQuestions: [],
      };

    default:
      return state;
  }
};
